import React from "react";
import "../../../../../styles/Pages/Financial/CashOutFlow/Charity/DetailView.style.css";

const DetailsView = ({
  onClose,
  data = {},
  description = "",
  highlightKey = "donationId",
}) => {
  const renderRows = (dataObj) => {
    return Object.entries(dataObj).map(([label, value]) => (
      <div key={label}>
        <span className="label">{label}</span>
        <p>
          {label.toLowerCase() === highlightKey.toLowerCase() ? (
            <>
              <span className="highlight">#</span>
              {value}
            </>
          ) : (
            value
          )}
        </p>
      </div>
    ));
  };

  return (
    <div className="details-view-container">
      <div className="details-header">
        <h3>Details view</h3>
      </div>

      <div className="details-grid">{renderRows(data)}</div>

      {description && (
        <div className="description-section">
          <span className="label">Description</span>
          <p>{description}</p>
        </div>
      )}

      <button className="confirm-btn" onClick={onClose}>
        Okay
      </button>
    </div>
  );
};

export default DetailsView;
